import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import Input from "../../components/input";
import { sportAdd, uploadCms } from "../../api/endpoint";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../../components/loader";

const AddSportModal = ({
  isAddSportOpen,
  closeAddSportModal,
  fetchSportsList,
}) => {
  const [sport, setSport] = useState("");
  const [icon, setIcon] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const handleAddSport = async () => {
    if (!sport) {
      setError("This field is required");
      return;
    }
    let fileName = "";
    if (icon) {
      const formData = new FormData();
      formData.append("file", icon);
      try {
        setLoading(true);
        const uploadResponse = await axios.post(uploadCms, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (uploadResponse.status === 200) {
          fileName = uploadResponse.data.message;
          fileName = fileName?.split("/")?.pop();
        }
      } catch (error) {
        console.error("Error uploading icon", error);
        toast.error("Error uploading icon");
        return;
      } finally {
        setLoading(false);
      }
    }
    const body = {
      sportName: sport,
      icon: icon ? fileName : null,
    };
    try {
      const response = await axios.post(sportAdd, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      });
      if (response?.status == 200) {
        toast.success(response?.data?.message);
        handleClose();
        fetchSportsList();
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message);
    }
  };

  const handleClose = () => {
    setSport("");
    setIcon(null);
    setError("");
    closeAddSportModal();
  };

  return (
    <>
      {loading && <Loader/>}
      <Modal show={isAddSportOpen} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Sport</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <Input
                label="Sport Name"
                type="text"
                placeholder="Sport Name"
                value={sport}
                onChange={(e) => setSport(e.target.value)}
              />
              {error && <div className="text-danger">* {error}</div>}
            </div>
            <Input
              label="Sport Icon"
              type="file"
              accept="image/png, image/jpeg"
              value={icon}
              onChange={(e) => setIcon(e.target.files[0])}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button text="Add Sport" callBack={handleAddSport} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSportModal;
